import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from './constants.service';

@Injectable({
	providedIn: 'root'
})
export class AddToQueueService {

	constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }

	getTiersList(periodId): Observable<any> {

		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/getTiersByPeriodId/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError)
			);
	}

	saveAddToQueue(periodId, tierId, targetPercentage, userId) {
		const InData  = {
			periodId: periodId,
			tierposition: tierId,
			targetPercentage: targetPercentage,
			userId: Number(userId)
		}
		return this.http.post(`${this.constantsService.baseAPIURL}/gihome/addToQueue`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}


	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}


}